<template>
  <div class="live-wrapper" :style="{ 'background-image': 'url(' + bg + ')' }">
    <div class="live-frame"></div>
    <div class="iframe-wrapper" v-if="isReady">
      <iframe
        width="100%"
        height="100%"
        :src="playerUrl"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        scrolling="no"
      ></iframe>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
export default {
  components: {
    Navbar
  },
  data() {
    return {
      isTimeUp: false,
      openningTime: null,
      minutesLeft: null,
      interval: null,
      user: null,
      playerUrl: null,
      isReady: false,
      bg: null
    };
  },
  created() {
    let regId = this.$root.regId || $cookies.get(this.$root.event.id);
    console.log(regId);

    if (!regId) {
      this.$router.push("/" + this.$router.currentRoute.params.id);
    } else {
      $cookies.set(this.$root.event.id, regId);
    }
    this.$axios
      .post("/postParticipant", {
        regId: regId,
        deviceId: this.$root.deviceId
      })
      .then(res => {
        this.user = this.participant;
        this.playerUrl =
          res.data.playerUrl +
          "?uid=" +
          res.data.participant.email +
          "&name=" +
          res.data.participant.name;
        this.isReady = true;
      });

    this.bg =
      process.env.VUE_APP_API_SERVER + this.$root.event.backgroundImage.url;
  }
};
</script>

<style lang="scss">
.live-wrapper {
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;
  background-position-y: top;
  background-attachment: fixed;
  height: 100vh;
  overflow: scroll;
}
.live-frame {
  max-width: 854px;
  margin: auto;
  margin-top: 64px;
}
.iframe-wrapper {
  width: 100%;
  max-width: 854px;
  margin: auto;
  margin-bottom: 72px;
  background-color: transparent;
  position: relative;
  display: block;
  overflow: hidden;
  border-radius: 8px;
  &::before {
    padding-top: calc(56.25% + 382px);
    content: "";
    display: block;
  }
}

iframe {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
